module.exports = __webpack_public_path__ + "static/media/吾股复盘@2x.96e381e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/吾股复盘@2x.png
// module id = 1524
// module chunks = 0